import React, { useState, useEffect } from 'react';

import { OptionRow } from '../../../../design-system/components/mobile';

/**
 * The sort chooser, MOBILE ONLY.
 *
 * At and above the 1024px handoff sorting is a `Select` in the toolbar, so
 * there is no desktop counterpart and this deliberately does not branch: it is
 * the body of a sort `Sheet` and it emits `ds-*` only.
 *
 * The page owns the sheet, its header and its dismissal, which is why the old
 * `.sorting-header` with its own title and hand-rolled multiplication-sign
 * close button is gone. Choosing a sort closes the sheet, because the result
 * set changes underneath it and there is nothing left to decide.
 */
const MarketplaceSorting = ({ onSortChange, sortOptions, onClose, value }) => {
  const [selected, setSelected] = useState(value ?? sortOptions[0]?.value ?? '');

  // Keep the highlighted option in sync with the current sort.
  useEffect(() => {
    if (value !== undefined) {
      setSelected(value);
    }
  }, [value]);

  const handleChange = (next) => {
    setSelected(next);
    onSortChange(next);
    if (onClose) onClose();
  };

  return (
    <div role="radiogroup" aria-label="Sort by">
      {sortOptions.map((option) => (
        <OptionRow
          key={option.value}
          control="radio"
          label={option.label}
          inputProps={{
            name: 'marketplace-sorting',
            value: option.value,
            checked: selected === option.value,
            onChange: () => handleChange(option.value),
          }}
        />
      ))}
    </div>
  );
};

export default MarketplaceSorting;
